import { Button, Text } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";

export interface RegionOptionProps {
  title: string;
  icon: string;
  selected: boolean;
  onClick: () => void;
}

export const RegionOption = ({
  title,
  icon,
  selected,
  onClick,
}: RegionOptionProps) => {
  return (
    <Box>
      <Button
        onClick={onClick}
        borderRadius="full"
        width={{ base: "90px", md: "120px" }}
        height={{ base: "90px", md: "120px" }}
        fontSize={{ base: "5xl", md: "6xl" }}
        backgroundColor={selected ? "whiteAlpha.500" : "whiteAlpha.200"}
        _hover={{
          backgroundColor: selected ? "whiteAlpha.500" : "whiteAlpha.300",
        }}
      >
        {icon}
      </Button>
      <Text fontSize="xs" color="white" textAlign="center" mt={2}>
        {title}
      </Text>
    </Box>
  );
};
